<template>
    <v-container fluid class="bg-main">
        <v-layout row>
            <v-flex xs12>

                <v-card>
                    <v-card-title>
                        Orders:
                        <v-spacer></v-spacer>

                        <v-text-field
                                v-model="search"
                                outlined
                                append-icon="search"
                                label="Tìm theo Group Telegram ID"
                                hide-details
                        ></v-text-field>
                        <div class="float-right div-icon-action">
                            <v-icon @click="print">mdi-printer</v-icon>
                        </div>
                        <div class="float-right div-icon-action ml-0">
                            <export-excel :data="desserts">
                                <v-icon>mdi-file-export</v-icon>
                            </export-excel>
                        </div>
                    </v-card-title>
                    <div id="telegram-activity-log">
                        <v-data-table
                            :headers="headers"
                            :items="desserts"
                            :options.sync="options"
                            :server-items-length="totalDesserts"
                            :loading="loading"
                            class="elevation-1">
                            
                            <!--group_telegram-->
                            <template v-slot:item.group_telegram="{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.group_telegram" target="_blank">
                                        {{ item.group_telegram }}
                                    </a>
                                </v-layout>
                            </template>

                            <template v-slot:item.group_get_member="{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.group_get_member" target="_blank">
                                        {{ item.group_get_member }}
                                    </a>
                                </v-layout>
                            </template>

                            <!--quantity-->
                            <template v-slot:item.quantity="{item}">
                                {{ item.quantity | currency_init }}
                            </template>

                            <!--price-->
                            <template v-slot:item.price="{item}">
                                {{ item.price | currency_init }}
                            </template>

                            <!--mobile-->
                            <template v-slot:item.mobile="{item}">
                                {{ item.mobile }}
                            </template>

                            <!--status-->
                            <template v-slot:item.status="{ item }">
                                <v-chip v-if="item.status == 1" color="blue" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-sync</v-icon>
                                    </v-avatar>
                                    {{ item.statusName }}
                                </v-chip>
                                <v-chip v-if="item.status == 2" color="orange" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-sync-circle</v-icon>
                                    </v-avatar>
                                    {{ item.statusName }}
                                </v-chip>
                                <v-chip v-if="item.status == 3" color="success" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-check</v-icon>
                                    </v-avatar>
                                    {{ item.statusName }}
                                </v-chip>
                                <v-chip v-if="item.status == 4" color="danger" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-cancel</v-icon>
                                    </v-avatar>
                                    {{ item.statusName }}
                                </v-chip>
                            </template>
                            
                            <!--note-->
                            <template v-slot:item.note="{item}">
                                {{ item.note }}
                            </template>

                            <!--created_at-->
                            <template v-slot:item.created_at="{item}">
                                <v-layout row>
                                    {{ item.created_at }}
                                </v-layout>
                            </template>

                        </v-data-table>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {
        TELEGRAM_HISTORY
    } from "../../store/actions.type";
    import {baseUrl, centralUrl} from "../../config";

    export default {
        data() {
            return {
                search: '',
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    {text: '#', value: 'id', align: "center"},
                    {text: 'Group telegram', value: 'group_telegram', align: "center"},
                    {text: 'Group lấy member', value: 'group_get_member', align: "center"},
                    {text: 'Số lượng member cần kéo', value: 'quantity', align: "center"},
                    {text: 'Tổng tiền', value: 'price', align: "center"},
                    {text: 'Số điện thoại liên hệ', value: 'mobile', align: "center"},
                    {text: 'Trạng thái', value: 'status', align: "center"},
                    {text: 'Ghi chú', value: 'note', align: "center"},
                    {text: 'Ngày mua', value: 'created_at', align: "center"},
                ],
                baseUrl: baseUrl,
                centralUrl: centralUrl,
            }
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },
            search() {
                this.options.page = 1;
                this.getDataFromApi()
                    .then(data => {
                        this.desserts = data.items,
                            this.totalDesserts = data.total
                    });
            }
        },
        mounted() {
            this.getDataFromApi()
            .then(data => {
                this.desserts = data.items,
                    this.totalDesserts = data.total
            });
        },
        methods: {
            async getDataFromApi() {
                this.loading = true
                const { sortBy, sortDesc, page } = this.options
                let pageNumber = page.page || this.options.page;

                let rowsPerPage = page.itemsPerPage || this.options.itemsPerPage;
                let data = await this.$store.dispatch(TELEGRAM_HISTORY, {
                    'search': this.search,
                    'page' : pageNumber,
                    'rowsPerPage' : rowsPerPage
                });

                let items = data.orders
                const total = data.total

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }

                this.loading = false;
                return {items,total};
            },
            print() {
                this.$htmlToPaper("telegram-activity-log-print");
            },
        },
    }
</script>
<style lang="scss">
    .div-icon-action {
        i {
            cursor: pointer;
        }
    }

    .a-post-link {
        text-decoration: none;
    }

    #telegram-activity-log-print {
        display: none;
    }
</style>
